import $ from 'jquery'

export default class {

  constructor ($el) {
    this.$el = $el
    this.activeImage = null
    this.$activeTrigger = null
    this.$target = null
  }

  initialise () {
    this.$target = $('[data-map-target]')
    this.$el.on('click', '[data-map-image]', (e) => {
      let $trigger = $(e.currentTarget)
      let image = $trigger.data('map-image')
      if (!image) {
        return
      }
      this.activate($trigger, image)
    })
    this.$el.find('[data-map-image]').first().trigger('click')
  }

  activate ($trigger, image) {
    if (this.$activeTrigger) {
      this.$activeTrigger.removeClass('is-active')
    }
    $trigger.addClass('is-active')
    this.$target.css({
      'backgroundImage': `url(${image})`,
    })
    this.$activeTrigger = $trigger
  }

}
